import React from 'react';
import { ProgramInfo } from '../../../generated/graphqlModels';
import { Box, SimpleGrid, Text } from '@chakra-ui/react';

interface ShortInfoProps extends ProgramInfo {}

const InfoItem = (props: { title: string; value: string }) => {
  return (
    <Box
      textAlign="center"
      _even={{
        borderRight: '1px solid #E2E8F0',
        borderLeft: '1px solid #E2E8F0',
      }}
      _last={{
        borderRight: 'none',
        borderLeft: '1px solid #E2E8F0',
      }}
      paddingX="10px"
      display="flex"
      flexDir="column"
      justifyContent="center"
    >
      <Text fontSize="xl" fontWeight="700">
        {props.title}
      </Text>
      <Text fontSize="xl" fontWeight="500">
        {props.value}
      </Text>
    </Box>
  );
};

const ShortInfo = (props: ShortInfoProps) => {
  const minTrack = props.tracks?.length
    ? props.tracks?.reduce(
        (acc, cur) =>
          acc!.estimatedDuration < cur.estimatedDuration ? acc : cur,
        props.tracks[0],
      )
    : null;
  const maxTrack = props.tracks?.length
    ? props.tracks?.reduce(
        (acc, cur) =>
          acc!.estimatedDuration > cur.estimatedDuration ? acc : cur,
        props.tracks[0],
      )
    : null;
  const minTime =
    props.minHours != null
      ? props.minHours
      : minTrack
      ? Math.round(minTrack?.estimatedDuration / 3600)
      : 30;
  const maxTime =
    props.maxHours != null
      ? props.maxHours
      : maxTrack
      ? Math.round(maxTrack?.estimatedDuration / 3600)
      : 120;
  return (
    <SimpleGrid
      columns={[1, 2, 2, 2, 4]}
      spacing="40px"
      border="2px solid #E2E8F0"
      borderRadius="14px"
      padding="24px 4px"
      justifyContent="center"
      alignItems="center"
      marginTop="20px !important"
      w={'100%'}
      color="white"
      background="#2256ff"
    >
      <InfoItem
        title="Grades"
        value={`${props.minGrade} - ${props.maxGrade}`}
      />
      <InfoItem
        title="Classroom hours"
        value={
          minTime !== maxTime ? `${minTime}h - ${maxTime}h` : `${maxTime}h`
        }
      />
      <InfoItem
        title="Knowledge Prerequisites"
        value={props.knowledgePrerequisites || 'None'}
      />
      <InfoItem
        title="Standards Alignment"
        value={props.standardsAlignment || 'NGSS, ISTE'}
      />
    </SimpleGrid>
  );
};

export default ShortInfo;
